import GetSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/get";

import locationModuleActions from "./locationModule/actions";
import orgModuleActions from "./orgModule/actions";
import vendorModuleActions from "./vendorModule/actions";

const executeGetQuery = async (query, queryParams = {}) => {
  const proxy = new GetSimpatraServiceProxy();
  const response = await proxy.execute(query, queryParams);
  return response ? response.data : null;
};

const fetchPatientAccountDetailsById = async (_, patientId) => {
  const proxy = new GetSimpatraServiceProxy();
  const query = `accounts/v1/patient/${patientId}`;
  return await executeGetQuery(query);
};

const fetchPrescribers = async ({ commit }, { state, accessType }) => {
  const query = `/accounts/v1/state/${state}/prescribers/${accessType}`;
  const data = await executeGetQuery(query);
  commit("setPrescriberLookup", data);
  return data;
};

export default {
  fetchPatientAccountDetailsById,
  ...orgModuleActions,
  ...vendorModuleActions,
  ...locationModuleActions,
  fetchPrescribers,
};
